import { jsx } from "react/jsx-runtime";
import { Box, TooltipRenderer, Text, Badge } from "braid-design-system";
import { badgeContainer } from "./index.css.mjs";
const BadgeWithTooltip = ({
  id,
  badgeTone,
  tooltipText,
  badgeText
}) => /* @__PURE__ */ jsx(Box, { className: badgeContainer, children: /* @__PURE__ */ jsx(
  TooltipRenderer,
  {
    id,
    placement: "bottom",
    tooltip: /* @__PURE__ */ jsx(Text, { children: tooltipText }),
    children: ({ triggerProps }) => /* @__PURE__ */ jsx(Box, { ...triggerProps, children: /* @__PURE__ */ jsx(Badge, { tone: badgeTone, children: badgeText }) })
  }
) });
export {
  BadgeWithTooltip
};
